import { render, staticRenderFns } from "./DinamicSelector.vue?vue&type=template&id=dcf2cd7a&scoped=true"
import script from "./DinamicSelector.vue?vue&type=script&lang=js"
export * from "./DinamicSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf2cd7a",
  null
  
)

export default component.exports